const DriveSetting = ({
  naviSearch,
  setNaviSearch
}) => {
  const togglePreferences = (type) => {
    const display = type === naviSearch.type ? 'block' : 'none';
    return {display};
  };
  return (
    <div className="car-options route-option-group" style={togglePreferences('drive') }>
      <div className="option-item">
        <input type="checkbox" id="car-condition-0" name="chg" value="0" checked={naviSearch.drive.chg === 1}
          onChange={() => setNaviSearch({...naviSearch, drive: {...naviSearch.drive, chg: naviSearch.drive.chg === 1 ? 0 : 1}})} />
        <label htmlFor="car-condition-0">有料道路を利用する</label>
      </div>
      <div className="option-item">
        <input type="checkbox" id="car-condition-1" name="smartic" value="0" checked={naviSearch.drive.smartic === 1}
          onChange={() => setNaviSearch({...naviSearch, drive: {...naviSearch.drive, smartic: naviSearch.drive.smartic === 1 ? 0 : 1}})} />
        <label htmlFor="car-condition-1">スマートICを利用する</label>
      </div>
      <div className="option-item">
        {/* 車種のセレクトＢＯＸ */}
        <label className="option-car-type" htmlFor="car-vehicle-type">車種</label>
        <select id="car-vehicle-type" className="datetime-select"
          value={naviSearch.drive.vt}
          onChange={(e) => setNaviSearch({...naviSearch, drive: {...naviSearch.drive, vt: parseInt(e.target.value)}})}
        >
          {Object.entries([
            [0, '軽自動車'],
            [1, '普通自動車'],
            [2, '中型車'],
            [3, '大型車'],
            [4, '特大車']
          ]).map(([key, [val, label]]) => (
            <option key={key} value={val}>{label}</option>
          ))}
        </select>
      </div>
      <div className="option-item">
        ＊車種は有料道路を利用する際の料金計算で利用します。 <br />
        ＊ETC割引は考慮されません。
      </div>
    </div>
  );
};

export default DriveSetting;